import * as React from 'react';
import { ICellRendererParams } from '@ag-grid-community/core';
import { style } from 'typestyle';
import ImageCropperModal from 'src/components/ImageCropper/ImageCropperModal/ImageCropperModal';
import { resolvePath } from 'src/cdn';

import noImagePath from 'src/common-ui/images/noimage.jpg';
import { imageCellDragOverStyle } from 'src/components/ImageRendererWithHover/ImageRendererWithHover';
const noImage = resolvePath(noImagePath);

const styles = {
  imageContainer: style({
    display: 'grid',
    justifyItems: 'center',
  }),
  imageContainerDragOver: imageCellDragOverStyle,
  image: style({
    width: '50%',
  }),
  button: style({
    backgroundColor: 'transparent',
    border: '0 none',
    color: 'var(--teal)',
    fontWeight: 600,
    lineHeight: '1',
    padding: '0.25rem 1rem',
    textTransform: 'uppercase',
  }),
};

type Props = {
  showEditButton?: boolean;
  /** Used for drag and drop functionality from editable grid */
  onFileDrop?: (files: FileList) => void;
} & ICellRendererParams;

type State = {
  open: boolean;
  isDragOver: boolean;
};

export class ImageCellRenderer extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      open: false,
      isDragOver: false,
    };
  }

  updateImage = (image: string) => {
    this.props.setValue && this.props.setValue(image);
    this.closeModal();
  };

  editClicked = () => {
    this.setState({
      open: !this.state.open,
    });
  };

  closeModal = () => {
    this.setState({
      open: false,
    });
  };

  handleDragEnter = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ isDragOver: true });
  };

  handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
  };

  handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ isDragOver: false });
  };

  handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ isDragOver: false });

    const { onFileDrop } = this.props;
    if (onFileDrop && e.dataTransfer.files.length > 0) {
      onFileDrop(e.dataTransfer.files);
    }
  };

  render() {
    const { showEditButton } = this.props;
    const { open, isDragOver } = this.state;
    const image = this.props.getValue ? this.props.getValue() : null;

    const editButtonContent = showEditButton ? (
      <button className={styles.button} onClick={() => this.editClicked()} type="button">
        Edit
      </button>
    ) : (
      undefined
    );

    return (
      <div
        className={isDragOver ? styles.imageContainerDragOver : styles.imageContainer}
        onDragEnter={this.handleDragEnter}
        onDragOver={this.handleDragOver}
        onDragLeave={this.handleDragLeave}
        onDrop={this.handleDrop}
      >
        <img alt="" className={styles.image} src={image || noImage} />
        {editButtonContent}

        <ImageCropperModal
          open={open}
          passedImage={image}
          returnImage={this.updateImage}
          closeModal={this.closeModal}
        />
      </div>
    );
  }
}
